import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';

export const MuiAlertStyle = makeStyles((theme) => ({
    root: {
        width: '720px',
        borderRadius: '16px',
        boxShadow: '0px 4px 4px rgba(174, 180, 210, 0.4)',
        backdropFilter: 'blur(4px)',
        '& .MuiAlert-icon': {
            marginRight: '24px',
        },
        '& .MuiAlert-message': {
            display: 'flex',
            alignItems: 'center',
        },
        color: 'white',

        [theme.breakpoints.down('sm')]: {
            '& .MuiAlert-icon': {
                marginRight: '10px',
            },
            '& .MuiAlert-action': {
                paddingLeft: 0,
            },
        },
    },
    success: {
        background: '#646882',
        boxShadow: '0px 4px 4px rgba(174, 180, 210, 0.4)',
    },
    error: {
        background: 'rgba(69, 74, 103, 0.8)',
        boxShadow: '0px 4px 4px rgba(174, 180, 210, 0.4)',
    },
    info: {
        background: 'rgba(69, 74, 103, 0.98)',
        boxShadow: '-1px 9px 18px rgba(95, 102, 140, 0.34)',

        [theme.breakpoints.up('sm')]: {
            width: '33.33vw',
        },
    },
}));

export const StyledIconContainer = styled.div`
    ${({ theme }) => `
        background-color: ${theme.palette.common.gray2};
        width: 32px;
        height: 32px;

        display: flex;
        align-items: center;
        justify-content: center;

        border-radius: 50%;
    `}
`;
